<ng-container *ngIf="(borrower$ | async) as borrower">
  <div class="column-grid tw-justify-between tw-place-items-center tw-pr-2">
    <h2 mat-dialog-title class="mb-0">Change {{ data?.type === 'borrower' ? 'Assignment' : 'Ownership' }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon class="close">close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <ng-container *ngIf="data?.type === 'deal' else borrowerTemplate">
      <div>Change Deal Owner</div>
    </ng-container>
    <ng-template #borrowerTemplate>
      <div>Change assignment of
        <strong>{{ borrower.name }}</strong>
        from <strong>{{ borrower.assignedLenderName }}</strong>
        to...
      </div>
    </ng-template>
    <form [formGroup]="form" class="tw-mt-2">
      <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
      <div id="no-records" *ngIf="noMembersFound">No Team Members found</div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions  align="end" class="dialog-footer-container">
    <div [ngClass]="{
      'progress-button': true,
      'progress-button--working': saving$ | async
    }">
      <button
        type="button"
        class="tw-mr-2"
        mat-button
        mat-dialog-close
        [disabled]="saving$ | async"
      >Cancel</button>
      <button data-cy="change-assignment-save" mat-raised-button color="primary" (click)="save()" [disabled]="((model.teamMemberId === 0) || saving)">
        <span class="progress-button-text">Confirm</span>
        <mat-spinner class="progress-button-spinner" diameter="24"></mat-spinner>
      </button>
    </div>
  </mat-dialog-actions>
</ng-container>
